import { tryMailPlus0926Metadata } from '@proton/payments/core/coupon-config/configs/try-mail-plus-0926';

import type { CouponConfig } from './interface';

export const tryMailPlus0926Config: CouponConfig = {
    ...tryMailPlus0926Metadata,
};
